import { render, staticRenderFns } from "./bookingsubmit.vue?vue&type=template&id=101c2da3&scoped=true"
import script from "./bookingsubmit.vue?vue&type=script&lang=js"
export * from "./bookingsubmit.vue?vue&type=script&lang=js"
import style0 from "./bookingsubmit.vue?vue&type=style&index=0&id=101c2da3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101c2da3",
  null
  
)

export default component.exports